<template>
  <div class="empty" :style="props.style">
    <static-image class="icon" :src="iconSrc" />
    <div v-if="title" class="title">
      {{ title || '' }}
    </div>
    <div v-if="desc" class="desc">
      {{ desc || '' }}
    </div>
    <slot name="actions" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import StaticImage from '../StaticImage.vue'

/**
 * 空视图
 */
export type EmptyProps = {
  /**
   * 图标名，放置在@/assets/images/empty目录
   */
  icon: string
  /**
   * 标题
   */
  title?: string
  /**
   * 描述
   */
  desc?: string,
  /**
   * 样式
   */
  style?: any
}
const props = defineProps<EmptyProps>()
const iconSrc = computed(() => {
  return `@/assets/images/empty/${props.icon}`
})
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon {
    width: 118px;
    height: 118px;
    display: block;
  }

  .title {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 14px;
    color: $c-black1;
    text-align: center;
  }

  .desc {
    font-size: 12px;
    line-height: 1.5;
    color: $c-black3;
    text-align: center;
  }
}
</style>
